Object.defineProperty(exports,"__esModule",{value:true});var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _index=require("../victory-util/index");
var _victoryLabel=require("../victory-label/victory-label");var _victoryLabel2=_interopRequireDefault(_victoryLabel);
var _victoryTheme=require("../victory-theme/victory-theme");var _victoryTheme2=_interopRequireDefault(_victoryTheme);
var _index2=require("../victory-primitives/index");
var _victoryPortal=require("../victory-portal/victory-portal");var _victoryPortal2=_interopRequireDefault(_victoryPortal);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}


var fallbackProps={
cornerRadius:5,
pointerLength:10,
pointerWidth:10};var


VictoryTooltip=function(_React$Component){_inherits(VictoryTooltip,_React$Component);function VictoryTooltip(){_classCallCheck(this,VictoryTooltip);return _possibleConstructorReturn(this,(VictoryTooltip.__proto__||Object.getPrototypeOf(VictoryTooltip)).apply(this,arguments));}_createClass(VictoryTooltip,[{key:"getEvaluatedProps",value:function getEvaluatedProps(






































































































props){var

horizontal=

props.horizontal,datum=props.datum,pointerLength=props.pointerLength,pointerWidth=props.pointerWidth,cornerRadius=props.cornerRadius,width=props.width,height=props.height,orientation=props.orientation,dx=props.dx,dy=props.dy,text=props.text,active=props.active;

var style=Array.isArray(props.style)?
props.style.map(function(s){return _index.Helpers.evaluateStyle(s,datum,active);}):
_index.Helpers.evaluateStyle(props.style,datum,active);
var flyoutStyle=_index.Helpers.evaluateStyle(props.flyoutStyle,datum,active);
var padding=flyoutStyle&&flyoutStyle.padding||0;
var defaultDx=horizontal?padding:0;
var defaultDy=horizontal?0:padding;
var getDefaultOrientation=function getDefaultOrientation(){
var positive=horizontal?"right":"top";
var negative=horizontal?"left":"bottom";
return datum&&datum.y<0?negative:positive;
};
return(0,_assign3.default)(
{},
props,
{
style:style,
flyoutStyle:flyoutStyle,
dx:dx!==undefined?_index.Helpers.evaluateProp(dx,datum,active):defaultDx,
dy:dy!==undefined?_index.Helpers.evaluateProp(dy,datum,active):defaultDy,
cornerRadius:_index.Helpers.evaluateProp(cornerRadius,datum,active),
pointerLength:_index.Helpers.evaluateProp(pointerLength,datum,active),
pointerWidth:_index.Helpers.evaluateProp(pointerWidth,datum,active),
orientation:_index.Helpers.evaluateProp(orientation,datum,active)||getDefaultOrientation(),
width:_index.Helpers.evaluateProp(width,datum,active),
height:_index.Helpers.evaluateProp(height,datum,active),
active:_index.Helpers.evaluateProp(active,datum,active),
text:_index.Helpers.evaluateProp(text,datum,active)});


}},{key:"getCalculatedValues",value:function getCalculatedValues(

props){var
style=props.style,text=props.text,datum=props.datum,theme=props.theme,active=props.active;
var defaultLabelStyles=theme&&theme.tooltip&&theme.tooltip.style?
theme.tooltip.style:{};
var baseLabelStyle=Array.isArray(style)?
style.map(function(s){return(0,_defaults3.default)({},s,defaultLabelStyles);}):
(0,_defaults3.default)({},style,defaultLabelStyles);
var defaultFlyoutStyles=theme&&theme.tooltip&&theme.tooltip.flyoutStyle?
theme.tooltip.flyoutStyle:{};
var flyoutStyle=props.flyoutStyle?
(0,_defaults3.default)({},props.flyoutStyle,defaultFlyoutStyles):defaultFlyoutStyles;
var labelStyle=Array.isArray(baseLabelStyle)?
baseLabelStyle.map(function(s){return _index.Helpers.evaluateStyle(s,datum,active);}):
_index.Helpers.evaluateStyle(baseLabelStyle,datum,active);
var labelSize=_index.TextSize.approximateTextSize(text,labelStyle);
var flyoutDimensions=this.getDimensions(props,labelSize,labelStyle);
var flyoutCenter=this.getFlyoutCenter(props,flyoutDimensions);
return{labelStyle:labelStyle,flyoutStyle:flyoutStyle,labelSize:labelSize,flyoutDimensions:flyoutDimensions,flyoutCenter:flyoutCenter};
}},{key:"getFlyoutCenter",value:function getFlyoutCenter(

props,dimensions){var
x=props.x,y=props.y,dx=props.dx,dy=props.dy,pointerLength=props.pointerLength,orientation=props.orientation;var
height=dimensions.height,width=dimensions.width;
var sign=orientation==="right"||orientation==="top"?1:-1;
return{
x:orientation==="left"||orientation==="right"?
x+sign*(pointerLength+width/2+dx):x+sign*dx,
y:orientation==="top"||orientation==="bottom"?
y-sign*(pointerLength+height/2+dy):y-sign*dy};

}},{key:"getLabelPadding",value:function getLabelPadding(

style){
if(!style){
return 0;
}
var paddings=Array.isArray(style)?style.map(function(s){return s.padding;}):[style.padding];
return Math.max.apply(Math,_toConsumableArray(paddings).concat([0]));
}},{key:"getDimensions",value:function getDimensions(

props,labelSize,labelStyle){var
orientation=props.orientation,cornerRadius=props.cornerRadius,pointerLength=props.pointerLength,pointerWidth=props.pointerWidth;
var padding=this.getLabelPadding(labelStyle);
var getHeight=function getHeight(){
var calculatedHeight=labelSize.height+padding;
var minHeight=orientation==="top"||orientation==="bottom"?
2*cornerRadius:2*cornerRadius+pointerWidth;
return Math.max(minHeight,calculatedHeight);
};
var getWidth=function getWidth(){
var calculatedWidth=labelSize.width+padding;
var minWidth=orientation==="left"||orientation==="right"?
2*cornerRadius+pointerLength:2*cornerRadius;
return Math.max(minWidth,calculatedWidth);
};
return{
height:props.height||getHeight(props,labelSize,orientation)+padding/2,
width:props.width||getWidth(props,labelSize,orientation)+padding};

}},{key:"getLabelProps",value:function getLabelProps(

props,calculatedValues){var
flyoutCenter=calculatedValues.flyoutCenter,labelStyle=calculatedValues.labelStyle,labelSize=calculatedValues.labelSize,flyoutDimensions=calculatedValues.flyoutDimensions,dy=calculatedValues.dy,dx=calculatedValues.dx;var
text=props.text,datum=props.datum,labelComponent=props.labelComponent,index=props.index;
var textAnchor=labelStyle.textAnchor||"middle";
var getLabelX=function getLabelX(){
var sign=textAnchor==="end"?-1:1;
return flyoutCenter.x-sign*(flyoutDimensions.width-labelSize.width);
};
return(0,_defaults3.default)(
{},
labelComponent.props,
{
key:"label-"+index,
text:text,datum:datum,textAnchor:textAnchor,dy:dy,dx:dx,
style:labelStyle,
x:!labelStyle.textAnchor||labelStyle.textAnchor==="middle"?
flyoutCenter.x:getLabelX(),
y:flyoutCenter.y,
verticalAnchor:"middle",
angle:labelStyle.angle});


}},{key:"getFlyoutProps",value:function getFlyoutProps(

props,calculatedValues){var
flyoutDimensions=calculatedValues.flyoutDimensions,flyoutStyle=calculatedValues.flyoutStyle;var

x=

props.x,y=props.y,dx=props.dx,dy=props.dy,orientation=props.orientation,pointerLength=props.pointerLength,pointerWidth=props.pointerWidth,cornerRadius=props.cornerRadius,events=props.events,flyoutComponent=props.flyoutComponent,index=props.index;
return(0,_defaults3.default)(
{},
flyoutComponent.props,
{
x:x,y:y,dx:dx,dy:dy,orientation:orientation,pointerLength:pointerLength,pointerWidth:pointerWidth,cornerRadius:cornerRadius,events:events,
key:"flyout-"+index,
width:flyoutDimensions.width,
height:flyoutDimensions.height,
style:flyoutStyle});


}},{key:"renderTooltip",value:function renderTooltip(


props){
var evaluatedProps=this.getEvaluatedProps(props);var

flyoutComponent=
evaluatedProps.flyoutComponent,labelComponent=evaluatedProps.labelComponent,groupComponent=evaluatedProps.groupComponent,active=evaluatedProps.active,renderInPortal=evaluatedProps.renderInPortal;
if(!active){
return null;
}
var calculatedValues=this.getCalculatedValues(evaluatedProps);
var children=[
_react2.default.cloneElement(flyoutComponent,this.getFlyoutProps(evaluatedProps,calculatedValues)),
_react2.default.cloneElement(labelComponent,this.getLabelProps(evaluatedProps,calculatedValues))];

var tooltip=_react2.default.cloneElement(groupComponent,{role:"presentation"},children);
return renderInPortal?_react2.default.createElement(_victoryPortal2.default,null,tooltip):tooltip;
}},{key:"render",value:function render()

{
var props=_index.Helpers.modifyProps(this.props,fallbackProps,"tooltip");
return this.renderTooltip(props);
}}]);return VictoryTooltip;}(_react2.default.Component);VictoryTooltip.displayName="VictoryTooltip";VictoryTooltip.propTypes={active:_react.PropTypes.oneOfType([_react.PropTypes.bool,_react.PropTypes.func]),activateData:_react.PropTypes.bool,datum:_react.PropTypes.object,data:_react.PropTypes.array,events:_react.PropTypes.object,text:_react.PropTypes.oneOfType([_react.PropTypes.string,_react.PropTypes.number,_react.PropTypes.func,_react.PropTypes.array]),style:_react.PropTypes.oneOfType([_react.PropTypes.object,_react.PropTypes.array]),flyoutStyle:_react.PropTypes.object,x:_react.PropTypes.number,y:_react.PropTypes.number,dx:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.func]),dy:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.func]),width:_react.PropTypes.oneOfType([_index.PropTypes.nonNegative,_react.PropTypes.func]),height:_react.PropTypes.oneOfType([_index.PropTypes.nonNegative,_react.PropTypes.func]),orientation:_react.PropTypes.oneOfType([_react.PropTypes.oneOf(["top","bottom","left","right"]),_react.PropTypes.func]),pointerLength:_react.PropTypes.oneOfType([_index.PropTypes.nonNegative,_react.PropTypes.func]),pointerWidth:_react.PropTypes.oneOfType([_index.PropTypes.nonNegative,_react.PropTypes.func]),cornerRadius:_react.PropTypes.oneOfType([_index.PropTypes.nonNegative,_react.PropTypes.func]),horizontal:_react.PropTypes.bool,labelComponent:_react.PropTypes.element,flyoutComponent:_react.PropTypes.element,groupComponent:_react.PropTypes.element,index:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.string]),renderInPortal:_react.PropTypes.bool,theme:_react.PropTypes.object};VictoryTooltip.defaultProps={theme:_victoryTheme2.default.grayscale,active:false,renderInPortal:true,labelComponent:_react2.default.createElement(_victoryLabel2.default,null),flyoutComponent:_react2.default.createElement(_index2.Flyout,null),groupComponent:_react2.default.createElement("g",null)};VictoryTooltip.defaultEvents=[{target:"data",eventHandlers:{onMouseOver:function onMouseOver(targetProps){return[{target:"labels",mutation:function mutation(){return{active:true};}},{target:"data",mutation:function mutation(){return targetProps.activateData?{active:true}:{active:undefined};}}];},onMouseOut:function onMouseOut(){return[{target:"labels",mutation:function mutation(){return{active:undefined};}},{target:"data",mutation:function mutation(){return{active:undefined};}}];}}}];exports.default=VictoryTooltip;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-tooltip/victory-tooltip.js
// module id = 1387
// module chunks = 0